import { render } from "./hotelarea.vue?vue&type=template&id=2acb5886"
import script from "./hotelarea.vue?vue&type=script&lang=js"
export * from "./hotelarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__